import { render, staticRenderFns } from "./waitDealSignServiceForm.vue?vue&type=template&id=060f17c0&scoped=true&"
import script from "./waitDealSignServiceForm.vue?vue&type=script&lang=js&"
export * from "./waitDealSignServiceForm.vue?vue&type=script&lang=js&"
import style0 from "./waitDealSignServiceForm.vue?vue&type=style&index=0&id=060f17c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060f17c0",
  null
  
)

export default component.exports